// See web/app/themes/jcf-theme/acf/four-inconvenient-truths-module.twig

import "slick-carousel";
import $ from "jquery";

// setup
var sliderElem = $("#truths"),
  sliderBool = false,
  sliderBreakpoint = 768,
  sliderSettings = {
    adaptiveHeight: true,
    variableWidth: true,
    centerPadding: "4rem",
    ease: "Pow4.easeIn",
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: true,
    mobileFirst: true,
    customPaging: function (slider, i) {
      var n = ("0" + (i + 1)).slice(-2);
      return `<span class="dot" data-no="${n}">${n}</span>`;
    },
    responsive: [
      {
        breakpoint: sliderBreakpoint,
        settings: "unslick",
      },
    ],
  };

class Truths {
  init() {
    // console.log(sliderElem)

    sliderElem.on("init", function () {
      // console.log('init')
    });
    if (window.innerWidth <= sliderBreakpoint) {
      if (!sliderBool) {
        sliderElem.slick(sliderSettings);
        sliderBool = true;
      }
    } else {
      sliderBool = false;
    }
  }
}

export default Truths;
